import { Select } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { unitActions } from '../../actions';
import { useTranslation } from 'react-i18next';

const SelectSWVersion = ({ unit, unitSn, swOptions }) => {
  const i18n = useTranslation();
  const dispatch = useDispatch();
  const { selectedSWversionId } = useSelector((state) => state.unit);

  const uniqueSwOptions = swOptions?.filter(
    (version, index, self) =>
      index ===
        self.findIndex((v) => v.versionNumber === version.versionNumber) &&
      version.versionNumber !== unit.sw_version,
  );

  const isVersionExist = uniqueSwOptions?.some(
    (option) => option.versionNumber === unit.sw_version,
  );
  const updatedSwOptions = (
    !isVersionExist
      ? [
          ...uniqueSwOptions,
          {
            versionNumber: unit.sw_version,
            description: 'Online branch version',
            deprecated: null,
            releaseNotesUrl: null,
          },
        ]
      : uniqueSwOptions
  ).sort((a, b) =>
    a.versionNumber.localeCompare(b.versionNumber, undefined, {
      numeric: true,
      sensitivity: 'base',
    }),
  );

  useEffect(() => {
    dispatch(unitActions.storeSelectedSWVersionId(unit.sw_version));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unit.sw_version]);

  const onChangeSWVersion = (val) => {
    if (val) {
      dispatch(unitActions.storeSelectedSWVersionId(val));
    }
  };

  return (
    <span className='editUnitName d-flex flex-row align-items-center mt-1 flex-wrap'>
      {/* Shown only between 768px and 1024px */}
      <a
        href='https://solohelp.liveu.tv/hc/en-us/sections/13206843821851-Release-Notes'
        rel='noopener noreferrer'
        target='_blank'
        className='release-note-link responsive-only mb-1'
      >
        {i18n.t('RELEASENOTE')}
      </a>

      <div className='smalltxt mb-1' style={{ whiteSpace: 'nowrap' }}>
        {unitSn} -
      </div>

      <div style={{ minWidth: '0' }}>
        <Select
          className='w-100'
          name='swVersion'
          value={selectedSWversionId}
          onChange={(value) => onChangeSWVersion(value)}
          onBlur={() => {
            dispatch(unitActions.onTouchSwVersionSelectField(true));
          }}
          size='small'
        >
          {updatedSwOptions.map(({ versionNumber }) => (
            <Select.Option
              value={versionNumber}
              key={versionNumber}
              disabled={unit.sw_version === versionNumber}
            >
              {versionNumber}
            </Select.Option>
          ))}
        </Select>
      </div>

      {/* Default position for larger and smaller screens */}
      <a
        href='https://solohelp.liveu.tv/hc/en-us/sections/13206843821851-Release-Notes'
        rel='noopener noreferrer'
        target='_blank'
        className='release-note-link default-view ml-2'
      >
        {i18n.t('RELEASENOTE')}
      </a>
    </span>
  );
};

export default SelectSWVersion;
